import { type FC, type ReactNode } from 'react'
import { AdvertisingProvider } from 'react-advertising'

import { AdvertisingScripts } from '@/lib/ads/AdvertisingScripts'
import { prebidConfig } from '@/lib/ads/components/prebid/prebidConfig'
import { useSrpAds } from '@/lib/ads/hooks/useSrpAds'

type SearchAdsWrapperProps = {
  isMobileForAds?: boolean
  children: ReactNode
}

export const SearchAdsWrapper: FC<SearchAdsWrapperProps> = ({ isMobileForAds, children }) => {
  const { gpt, gptConfig } = useSrpAds(isMobileForAds)

  const hasSlots = (gptConfig?.slots && gptConfig?.slots.length > 0) || false

  return (
    <>
      <AdvertisingScripts gpt={gpt} />
      <AdvertisingProvider config={gptConfig} plugins={prebidConfig} active={hasSlots}>
        {children}
      </AdvertisingProvider>
    </>
  )
}
